const allPromos = [
    {
        sportkey: "golf",
        name: "US Open Special",
        expires: "2026-06-22",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "$9.99/month",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "7 days free then $79.99/year",
            globalTag: "30 days free"
        }
    },
    {
        sportkey: "global",
        name: "US Open Special",
        expires: "2026-06-22",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "$9.99/month",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "7 days free then $79.99/year",
            globalTag: "30 days free"
        }
    },
    {
        sportkey: "cricket_off",
        name: "New Season Special",
        expires: "2026-05-31",
        monthly:{
            code: "ANALYZERM26",
            description: "7 days free then $2.99/month",
            normalPrice: "$9.99/month",
            globalTag: "7 days free"
        },
        yearly:{
            code: "ANALYZER26",
            description: "30 days free then $24.99/year",
            normalPrice: "7 days free then $79.99/year",
            globalTag: "30 days free"
        }
    }
]

const getPromo = (key) => {
    const promo = allPromos.find(p => p.sportkey === key);

    if(promo && new Date(promo.expires) > new Date())
    {
        return promo;
    }

    return null;
}


export {getPromo}